<template>
  <v-card
    elevation="2"
    rounded="0"
    class="subnav-header text-default-content"
    :class="{ 'subnav-header--inline': inline }"
    color="default-panel"
  >
    <div
      class="subnav-header-toolbar d-flex align-center px-4 py-1"
    >
      <v-tooltip
        v-if="back"
        location="bottom"
      >
        <template #activator="{ props }">
          <v-btn
            v-if="hasBackUrl"
            :to="back"
            class="mr-1 subnav-back-btn"
            icon
            variant="text"
            elevation="0"
            rounded="circle"
            density="comfortable"
            v-bind="props"
          >
            <v-icon size="small" color="grey-darken-1">mdi-backspace</v-icon>
          </v-btn>
          <v-btn
            v-else
            @click="back"
            class="mr-1 subnav-back-btn"
            icon
            variant="text"
            elevation="0"
            rounded="circle"
            density="comfortable"
            v-bind="props"
          >
            <v-icon size="small" color="grey-darken-1">mdi-backspace</v-icon>
          </v-btn>
        </template>
        <span>Go back</span>
      </v-tooltip>
      <v-toolbar-title>{{ title }}</v-toolbar-title>

      <base-view-header-btn
        v-if="hasTour"
        label="About the page"
        icon="mdi-help-box"
        @click="$emit('tour-view')"
        rounded="0"
        elevation="0"
        :color="($store.state.isDarkMode) ? '' : 'white'"
        :icon-color="($store.state.isDarkMode) ? 'primary-darken-1' : 'primary'"
      ></base-view-header-btn>

      <slot
        name="title"
      ></slot>

      <v-spacer></v-spacer>

      <div class="d-flex align-center">
        <slot
          name="filters"
        ></slot>
      </div>

      <div class="d-flex align-center">
        <slot
          name="actions"
        ></slot>
      </div>
    </div>

    <!-- e.g. Reports tabs — same card as title row so it reads as one section -->
    <slot name="extension" />
  </v-card>
</template>

<script>
export default {
  name: 'BaseViewHeader',

  props: {
    title: {
      type: String,
      default: '',
    },
    hasTour: {
      type: [Boolean, Function],
      default: false,
    },
    back: {
      type: [String, Function],
      default: '',
    },
    /**
     * When true (e.g. nested inside a tab pane), keep the header in document
     * flow instead of pinning it under the app bar.
     */
    inline: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['tour-view'],

  computed: {
    hasBackUrl: function () {
      return ((typeof this.back) == 'string');
    },
  },
};
</script>
